import * as yup from 'yup'

const schema = yup.object().shape({
  userId: yup.number().required(),
})

export default schema
